/**
 * Courses whose missed MCQs show on the Review page (SQL only for now). Kept
 * apart from reviewCourses.js so the navbar badge doesn't load curricula.
 */
export const REVIEW_COURSE_IDS = [
  "sql-fundamentals",
  "sql-queries",
  "sql-joins",
  "sql-aggregate-functions",
  "sql-subqueries",
  "sql-views",
  "sql-indexes",
  "sql-stored-procedures",
  "sql-projects",
];
